import { CommonKeys } from "../../common/enums";
import { FORMULAR_GROUP_SIGNATUREN_TYPE, SIGNATUR_DATA_TYPE, SIGNATUR_TYPE, SIGNATUREN_TYPE } from "../../common/formular-group-types";

const FormularGroupSignaturenSchema = {
    $id: "FormularGroupSignaturenSchema",
    title: "FormularGroupSignaturen Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_GROUP_SIGNATUREN_TYPE },
        [CommonKeys.ID]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string", nullable: true },
        [CommonKeys.ShowLabel]: { type: "boolean", nullable: true },
        Signaturen: { $ref: "FormularGroupSignaturenSignaturenSchema" }
    }
};

const FormularGroupSignaturenSignaturenSchema = {
    $id: "FormularGroupSignaturenSignaturenSchema",
    title: "FormularGroupSignaturenSignaturen Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: SIGNATUREN_TYPE },
        [CommonKeys.Values]: {
            type: "array",
            items: { $ref: "FormularGroupSignaturenSignaturSchema" }
        }
    }
};

const SIGNATUR_PROPERTIES = {
    [CommonKeys.Type]: { const: SIGNATUR_TYPE },
    [CommonKeys.ID]: { type: "string", nullable: true },
    [CommonKeys.Label]: { type: "string", nullable: true },
    Typ: { type: "number", nullable: true },
    Date: { type: "string", nullable: true },
    Identifier: { type: "number", nullable: true },
    IstErforderlich: { type: "boolean", nullable: true },
    Location: { type: "string", nullable: true },
    SignaturData: {
        type: "object",
        properties: {
            [CommonKeys.Type]: { const: SIGNATUR_DATA_TYPE },
            [CommonKeys.Value]: { type: "string", nullable: true }
        },
        nullable: true
    },
    NamePlainText: { type: "string", nullable: true }
};

const SIGNATUR_REQUIRED = [CommonKeys.Type, CommonKeys.ID, CommonKeys.Label]

const FormularGroupSignaturenSignaturSchema = {
    $id: "FormularGroupSignaturenSignaturSchema",
    title: "FormularGroupSignaturenSignatur Schema",
    type: "object",
    properties: SIGNATUR_PROPERTIES,
    required: SIGNATUR_REQUIRED
};

export const FORMULAR_GROUP_SIGNATUREN_SCHEMAS = [
    FormularGroupSignaturenSchema,
    FormularGroupSignaturenSignaturenSchema,
    FormularGroupSignaturenSignaturSchema
]